// data
import { countries } from "countries-list";

// components
import ProfileOverviewSection from "../components/BusinessProfileSections/ProfileOverviewSection/ProfileOverviewSection";
import OrganizationOwnershipSection from "../components/BusinessProfileSections/OrganizationOwnershipSection/OrganizationOwnershipSection";
import ServiceInformation from "../components/BusinessProfileSections/ServiceInformationSection/ServiceInformationSection";
import Certifications from "../components/BusinessProfileSections/ProfileCertifications/ProfileCertifications";
import NaicsCodes from "../components/BusinessProfileSections/NaicsCodesSection/NaicsCodesSection";
import ExportProfileSection from "../components/BusinessProfileSections/ExportProfileSection/ExportProfileSection";
import PerformanceHistorySection from "../components/BusinessProfileSections/PerformanceHistorySection/PerformanceHistorySection";
import SizeOverviewSection from "components/BusinessProfileSections/SizeOverviewSection/SizeOverviewSection";

export interface BusinessProfile {
  name: string;
  header: string;
  subTitle?: string;
  content: string;
  component?: any;
  componentParams?: object;
}

export const businessProfiles: BusinessProfile[] = [
  {
    name: "profileOverview",
    header: "Profile Overview",
    content: "Profile Overview",
    component: ProfileOverviewSection,
  },
  {
    name: "organizationOwnership",
    header: "Organization & Ownership",
    content: "Organization & Ownership",
    component: OrganizationOwnershipSection,
  },
  {
    name: "size",
    header: "Size",
    content: "Size",
    component: SizeOverviewSection,
  },
  {
    name: "certifications",
    header: "Certifications",
    subTitle: "Content!",
    content: "Content Content Content",
    component: Certifications,
  },
  {
    name: "naicsCodes",
    header: "NAICS Codes",
    subTitle: "Content!",
    content: "Content Content Content",
    component: NaicsCodes,
  },
  {
    name: "serviceInformation",
    header: "Service Information",
    subTitle: "Content!",
    content: "Content Content Content",
    component: ServiceInformation,
  },
  {
    name: "exportProfile",
    header: "Export Profile",
    content: "Export Profile",
    component: ExportProfileSection,
  },
  {
    name: "performanceHistory",
    header: "Performance History",
    content: "Content Content Content",
    component: PerformanceHistorySection,
  },
];

export const countryNames = Object.fromEntries(Object.entries(countries).map(([key, value]) => [key, value.name]));